import { Form, Input, Button, message } from "antd";
import SummaryApi from "../../../common/index";
import axios from "axios";
import { Link } from "react-router-dom";
import "../../../Styles/AdminStylings/PlatformAdminLogin.css";
import { useNavigate } from 'react-router-dom';
import logo from "../../../Assets/logo.gif";  // import your logo
 
const AdminLogin = ({ onLogin }) => {
  const navigate = useNavigate();
 
  const onFinish = async (values) => {
    try {
      const res = await axios({
        url: SummaryApi.platformAdminSignin.url,
        method: SummaryApi.platformAdminSignin.method,
        data: values,
      });
      localStorage.setItem("adminToken", res.data.token);
      if (onLogin) onLogin(res.data.admin);
      message.success(res.data.message);
      navigate("/admin/dashboard");
    } catch (err) {
      message.error(err.response?.data?.message || "Login failed");
    }
  };
 
  return (
    <div className="admin-login-container">
      {/* Large logo above card */}
      <img
        src={logo}
        alt="Book Local Logo"
        className="admin-login-logo"
      />
      <div className="admin-login-card">
        <h2 className="admin-login-title">Admin Login</h2>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input className="admin-login-input" placeholder="Enter your email" />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true }]}
          >
            <Input.Password className="admin-login-input" placeholder="Enter your password" />
          </Form.Item>
          <Form.Item>
            <Button
              style={{background:"#ee152d",color:"white" ,marginTop:"10px",height:"45px", borderRadius:"10px",fontWeight:"bold"}}
              htmlType="submit"
              
              block
            >
              Login
            </Button>
            <div className="admin-forgot">
              <Link to="/forgot-password" style={{ fontSize: "14px" ,margin:"10px"}}>
                Forgot Password?
              </Link>
            </div>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
 
export default AdminLogin;